import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';

const BookingModal = ({ open, onOpenChange }) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    toast({
      title: "Consultation Request Received",
      description: "Our team will contact you within 24 hours.",
    });
    setFormData({ name: '', email: '', phone: '', message: '' });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-sand-50 text-ink border border-ink/10 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-wide">Schedule Consultation</DialogTitle>
          <DialogDescription className="text-ink/60">
            Please provide your details and we'll contact you to arrange a meeting.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Input
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="bg-ink/5 border-ink/10 text-ink placeholder:text-ink/40"
            />
          </div>
          <div>
            <Input
              name="email"
              type="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              className="bg-ink/5 border-ink/10 text-ink placeholder:text-ink/40"
            />
          </div>
          <div>
            <Input
              name="phone"
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="bg-ink/5 border-ink/10 text-ink placeholder:text-ink/40"
            />
          </div>
          <div>
            <Textarea
              name="message"
              placeholder="Brief description of your legal needs"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              className="bg-ink/5 border-ink/10 text-ink placeholder:text-ink/40 resize-none"
            />
          </div>
          <Button type="submit" className="w-full bg-ink text-cream hover:bg-ink/90 font-medium tracking-wider">
            Submit Request
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;